import { apiRequest } from '@/api/helpers/apiRequest';
import type { SoftDeleteRoleTemplateResponse } from 'schemas';
import { SoftDeleteRoleTemplateResponseSchema } from 'schemas';
import { handleApiError } from '@/api/helpers/handleApiError';

/**
 * Soft deletes a role template by ID.
 * @param templateId - The UUID of the role template to delete
 * @returns Promise that resolves when the role template is successfully deleted
 */
export const softDeleteRoleTemplate = async (
  templateId: string
): Promise<{ message: string; deletedTemplateId: string }> => {
  try {
    return await apiRequest<
      { message: string; deletedTemplateId: string },
      SoftDeleteRoleTemplateResponse
    >(
      'PUT',
      `/api/role-templates/${templateId}/delete`,
      {},
      SoftDeleteRoleTemplateResponseSchema
    );
  } catch (error) {
    handleApiError(error);
  }
};
